module.exports = __webpack_public_path__ + "static/img/kaigonglv.0e177e28.png";